import {
  type OnboardingStepProps,
  OnboardingStepWrapper,
  type OnboardingStepWrapperProps,
} from "../OnboardingStepWrapper";
import { JobSearchAgreementStepContent } from "./JobSearchAgreementStepContent";

interface JobSearchAgreementStepProps extends Pick<
  OnboardingStepWrapperProps,
  "worker" | "progress" | "onBack" | "onNext" | "stage"
> {
  isOptional?: boolean;
  onSkip?: () => void;
}

export function JobSearchAgreementStep(props: JobSearchAgreementStepProps) {
  const { worker, progress, onBack, onNext, stage, isOptional = false, onSkip } = props;

  const stepProps = {
    worker,
    progress,
    stage,
    onNext,
    onBack,
  };

  return (
    <OnboardingStepWrapper
      {...stepProps}
      render={(renderProps: OnboardingStepProps) => (
        <JobSearchAgreementStepContent {...renderProps} isOptional={isOptional} onSkip={onSkip} />
      )}
    />
  );
}
